import { getShiftDiscoveryDefaultDateRange } from "./getShiftDiscoveryDefaultDateRange";
import { useShiftDiscoveryDaysToFetch } from "./useShiftDiscoveryDaysToFetch";

export function useGetShiftDiscoveryDefaultDateRange() {
  const daysToFetch = useShiftDiscoveryDaysToFetch();

  return getShiftDiscoveryDefaultDateRange(daysToFetch);
}
